import { QueryClient } from '@tanstack/react-query';
import { ReactElement } from 'react';

import { prepopulateCache } from '$shared/utils/react-query.utils';

import { createAuditEventDetailQuery } from '$features/audit-events/audit-events.api';
import { AuditEventDetailSidecar } from '$features/audit-events/detail/audit-event-detail-sidecar';

export async function auditDetailLoader(qClient: QueryClient, id: string): Promise<null> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- todo
  return prepopulateCache<any>(qClient, createAuditEventDetailQuery(id));
}

export function AuditEventDetailPage(): ReactElement {
  return <AuditEventDetailSidecar />;
}
